import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-body py-4" }
const _hoisted_2 = { class: "row g-4" }
const _hoisted_3 = {
  key: 0,
  class: "col-6 col-lg-4 col-xl-3"
}
const _hoisted_4 = { class: "col-6 col-lg-4 col-xl-3" }
const _hoisted_5 = {
  key: 1,
  class: "col-6 col-lg-4 col-xl-3"
}
const _hoisted_6 = {
  key: 2,
  class: "col-6 col-lg-4 col-xl-3"
}
const _hoisted_7 = {
  key: 3,
  class: "col-6 col-lg-4 col-xl-3"
}
const _hoisted_8 = {
  key: 4,
  class: "col-6 col-lg-4 col-xl-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_StatCard = _resolveComponent("StatCard")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 2,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loadingBalance]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card seq-card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          (_ctx.pt != 'bibo')
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode(_component_StatCard, {
                  compact: "",
                  label: "Consolidated Balance",
                  icon: "media/icons/duotone/Shopping/Wallet2.svg",
                  value: _ctx.balancedetails.overAllAvailableBalance,
                  "currency-symbol": _ctx.balancedetails.currency || '',
                  period: "",
                  decimals: 2
                }, null, 8, ["value", "currency-symbol"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_StatCard, {
              compact: "",
              label: `${_ctx.user.usid} Balance`,
              icon: "media/icons/duotone/Shopping/Money.svg",
              value: _ctx.balancedetails.balance,
              "currency-symbol": _ctx.balancedetails.currency || '',
              period: "",
              decimals: 2
            }, null, 8, ["label", "value", "currency-symbol"])
          ]),
          (_ctx.pt != 'bibo')
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode(_component_StatCard, {
                  compact: "",
                  label: "EC Wallet",
                  icon: "media/icons/duotone/Shopping/Credit-card.svg",
                  value: _ctx.balancedetails.ewalletbalance,
                  "currency-symbol": _ctx.ewalletCurrency,
                  period: "",
                  decimals: 2
                }, null, 8, ["value", "currency-symbol"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.pt != 'bibo' && _ctx.pt != 'ecc' && _ctx.ccode === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode(_component_StatCard, {
                  compact: "",
                  label: "MG Pay",
                  icon: "media/icons/duotone/Shopping/Wallet.svg",
                  value: _ctx.balancedetails.matchinpaybalance,
                  "currency-symbol": _ctx.balancedetails.currency || '',
                  period: "",
                  decimals: 2
                }, null, 8, ["value", "currency-symbol"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.pt != 'bibo')
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode(_component_StatCard, {
                  compact: "",
                  label: "PGI",
                  icon: "media/icons/duotone/Home/Air-ballon.svg",
                  value: _ctx.balancedetails.travelgc,
                  "currency-symbol": "",
                  period: "",
                  decimals: 0
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.pt != 'bibo')
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _createVNode(_component_StatCard, {
                  compact: "",
                  label: "Product GC",
                  icon: "media/icons/duotone/Shopping/Box2.svg",
                  value: _ctx.balancedetails.productgc,
                  "currency-symbol": "",
                  period: "",
                  decimals: 0
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2), [
      [_vShow, !_ctx.loadingBalance]
    ])
  ], 64))
}